import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=84532f18&scoped=true"
import script from "./culture.vue?vue&type=script&lang=js"
export * from "./culture.vue?vue&type=script&lang=js"
import style0 from "./culture.vue?vue&type=style&index=0&id=84532f18&prod&lang=stylus&scoped=true"
import style1 from "./culture.vue?vue&type=style&index=1&id=84532f18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84532f18",
  null
  
)

export default component.exports